import { z } from "zod";
import type { Workspace, PortalCommunications } from "./supplier-portal-model";
const text = z.string(), number = z.number().finite();
const visibility = z.enum(["ALL_INVITEES", "PRIVATE"]);
const costs = z.object({shipping:text,insurance:text,installation:text,other:text});
const workspace = z.object({
  offerStatus:text,
  rfq:z.object({rfqNo:text,title:text,deadlineAt:text,timezone:text,specificationVersion:text,items:z.array(z.object({id:text,lineNo:number,itemCode:text,description:text,quantity:number,unit:text,deliveryDate:text.nullable()}))}),
  draft:z.object({status:text,version:number,currency:text,deliveryLeadDays:number,paymentTermDays:number,validityDate:text,additionalCosts:costs,serverGrandTotal:text.nullable(),note:text,items:z.array(z.object({rfqItemId:text,unitPrice:text,serverTotal:text})),documents:z.array(z.object({id:text,originalName:text,securityStatus:text}))}).nullable(),
  history:z.array(z.object({id:text,version:number,currency:text,grandTotal:text,submittedAt:text})),
});
const communications = z.object({
  questions:z.array(z.object({id:text,body:text,status:text,createdAt:text,answer:z.object({body:text,visibility,answeredAt:text}).nullable()})),
  announcements:z.array(z.object({id:text,body:text,visibility,createdAt:text})),
});
export function parsePortalWorkspace(value: unknown): Workspace {
  const result = workspace.safeParse(value);
  if (!result.success) throw new Error("Teklif çalışma alanı yanıtı geçersiz.");
  return result.data;
}
export function parsePortalCommunications(value: unknown): PortalCommunications {
  const result = communications.safeParse(value);
  if (!result.success) throw new Error("Teklif iletişim yanıtı geçersiz.");
  return result.data;
}
